import React, { useEffect } from "react";
import { useState } from "react";
import { Box, Grid, Link, Paper, Typography } from "@material-ui/core";
import CardDashboardResumo from "../../components/CardDashboardResumo";
import CardDashboardConsumo from "../../components/CardDashboardConsumo";
import CardDashboardUltimasConsultas from "../../components/CardDashboardUltimasConsultas";
import { Link as RouterLink } from "react-router-dom";
import iconAnalisesCredito from "../../images/icon-analises-credito.svg";
import relatorioService from "../../services/relatorioService";

const Dashboard = (props) => {
    const [dadosDashboard, setDadosDashboard] = useState({
        valor_mes: 0.0,
        valor_semana: 0.0,
        valor_hoje: 0.0,
        positivo: 0,
        negativo: 0,
        em_processamento: 0,
        total_consultas_mes: 0,
        total_analises: 0,
        saldo_credito: 0.0,
    });

    const [relatorios, setRelatorios] = useState([]);

    useEffect(async () => {
        setDadosDashboard(await relatorioService.getDadosDashboard());
        setRelatorios(await relatorioService.getRelatoriosDashboard());
    }, []);

    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
        >
            <Box marginTop="1rem" width="65rem" maxWidth="95vw">
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={4}
                >
                    <Grid item xs={12}>
                        <Grid container direction="row" spacing={4}>
                            <Grid item md={7}>
                                <CardDashboardResumo dados={dadosDashboard} />
                            </Grid>
                            <Grid item md={5}>
                                <CardDashboardUltimasConsultas
                                    relatorios={relatorios}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container direction="row" spacing={4}>
                            <Grid item md={7} xs={12}>
                                <Paper>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                    >
                                        <Grid item>
                                            <Grid
                                                container
                                                direction="row"
                                                alignItems="stretch"
                                            >
                                                <Grid item>
                                                    <img
                                                        src={
                                                            iconAnalisesCredito
                                                        }
                                                        style={{
                                                            height: "100%",
                                                            padding: "0.8rem",
                                                        }}
                                                        alt="Icone de Análises de Credito"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        style={{
                                                            height: "100%",
                                                        }}
                                                    >
                                                        <Typography variant="h6">
                                                            {
                                                                dadosDashboard.total_analises
                                                            }
                                                        </Typography>
                                                        <Typography variant="body1">
                                                            Análises de crédito
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                style={{ height: "100%" }}
                                            >
                                                <Grid
                                                    item
                                                    style={{
                                                        padding: "0.8rem",
                                                    }}
                                                >
                                                    <Typography
                                                        component={"p"}
                                                        variant="body2"
                                                        align="center"
                                                    >
                                                        <Link
                                                            component={
                                                                RouterLink
                                                            }
                                                            to="/relatorios"
                                                            color="secondary"
                                                        >
                                                            Ver análises
                                                        </Link>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item md={5}>
                                <CardDashboardConsumo dados={dadosDashboard} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default Dashboard;
